export default {
  ITEM: 'item',
  COMPONENT: 'component'
}



// WEBPACK FOOTER //
// ./src/ItemTypes.js